//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import productAudioPlayerMixin from '@motionelements/core/src/components/mixins/productAudioPlayer.mixin';

export default {
  name: 'PreviewAudio',
  mixins: [productAudioPlayerMixin],
  inject: {
    isPopUp: {
      default: false,
    },
  },
  props: {
    element: Object,
    product2025Layout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      waveformHeight: 6,
      waveformSvgInstanceId: '',
    };
  },
  created() {
    this.resetWaveformSvgInstanceId();
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
    }),
    timeElapsedToMinutes() {
      return this.$tools.secondToMinutes(this.progress.timeElapsed / 1000);
    },
    details() {
      return _.get(this.element, 'mediaTypeDetails', _.get(this.element, 'media_type_details'));
    },
    // classProgressStatus() {
    //   let widthElapsed = 0;
    //
    //   const widthTotal = this.waveformWidth;
    //   widthElapsed = (this.progress.timeElapsed * widthTotal) / this.progress.timeTotal;
    //
    //   if (this.progress.timeTotal === 0) {
    //     widthElapsed = 0;
    //   }
    //
    //   const classObject = {
    //     opacity: 1,
    //     // waveformHeight are larger in PreviewAudio.vue (ProductPage)
    //     // clip: `rect(0,${widthElapsed}px,${_.get(this.waveformHeight, '', 3)}rem,0)`,
    //     clip: `rect(0,${widthElapsed}px,${this.waveformHeight || 3}rem,0)`,
    //   };
    //
    //   return classObject;
    // },
    progressDurationMs() {
      if (this.progress.timeTotal > 0) {
        return this.progress.timeTotal;
      }
      if (this.progress.timeEstimated > 0) {
        return this.progress.timeEstimated;
      }
      const durationSec = _.get(this.details, 'duration');
      return durationSec ? durationSec * 1000 : 0;
    },
    maskWidth() {
      const widthTotal = this.waveformWidth;
      const durationMs = this.progressDurationMs;
      if (!widthTotal || !durationMs) {
        return 0;
      }
      return (this.progress.timeElapsed * widthTotal) / durationMs;
    },
    rootClass() {
      return this.product2025Layout
        ? 'product2025-audio-preview w-100'
        : 'container pb-5';
    },
    outerRowClass() {
      return this.product2025Layout
        ? 'd-flex flex-row flex-nowrap align-items-start'
        : 'd-flex flex-sm-nowrap flex-column flex-sm-row align-items-center';
    },
    audioControlsRowClass() {
      return this.product2025Layout
        ? 'w-100 flex-grow-1 min-w-0 d-flex flex-row flex-nowrap align-items-start gap-2'
        : 'w-100 flex-grow-1 d-flex flex-column-reverse flex-sm-row align-items-center align-items-sm-end';
    },
    playButtonWrapClass() {
      return this.product2025Layout ? 'product2025-play flex-shrink-0' : 'mr-sm-3';
    },
    // Match legacy player: 100px SVG viewport with 96px-tall image inset 2px to avoid edge clipping.
    waveformViewBoxHeight() {
      return 100;
    },
    waveformImageY() {
      return 2;
    },
    product2025ViewBox() {
      const w = this.waveformWidth || 1;
      return `0 0 ${w} ${this.waveformViewBoxHeight}`;
    },
    waveformSvgHeight() {
      return 100;
    },
    waveformImageHeight() {
      return 96;
    },
  },
  watch: {
    windowWidth() {
      this.updateWaveformWidth(this.$refs.waveformWrapper.offsetWidth);
    },
    'element.id'(id, oldId) {
      if (id && oldId && id !== oldId) {
        this.resetWaveformSvgInstanceId();
      }
      if (!id || !oldId || id === oldId || !this.isPopUp) {
        return;
      }
      this.$nextTick(() => this.autoplayPopUpPreview());
    },
    'progress.timeElapsed'() {
      this.$nextTick(() => {
        if (this.$refs.waveformWrapper) {
          this.updateWaveformWidth(this.$refs.waveformWrapper.offsetWidth);
        }
      });
    },
  },
  mounted() {
    // this.updateWaveformWidth(this.$refs.waveformImage.offsetWidth);
    this.updateWaveformWidth(this.$refs.waveformWrapper.offsetWidth);
    if (this.isPopUp) {
      this.$nextTick(() => {
        this.focusPopUpPlayButton();
        this.autoplayPopUpPreview();
      });
    }
  },
  methods: {
    resetWaveformSvgInstanceId() {
      const elementId = _.get(this.element, 'id', 'audio');
      this.waveformSvgInstanceId = `${elementId}-${Date.now()}`;
    },
    focusPopUpPlayButton() {
      if (!this.isPopUp) {
        return;
      }
      this.$nextTick(() => {
        const btn = this.$refs.previewPlayButton;
        if (btn?.focus) {
          btn.focus({ preventScroll: true });
        }
      });
    },
    autoplayPopUpPreview() {
      if (!this.isPopUp || !this.audioUrl) {
        return;
      }
      this.detectSavedProgress();
      if (!this.isPlaying) {
        this.clickAudioPlayButton();
      }
      this.focusPopUpPlayButton();
    },
  },
};
